import { countWords } from "../../../Utils";
import { memo } from "react";
import classNames from "classnames";

export const WordCount = memo(({ textContent, maxLength, highlightOverage, wordCount }) => {
  const count = wordCount ?? countWords(textContent);
  return (
    <div className={classNames(["count", { "highlight-overage": count > maxLength && highlightOverage }])}>
      {count || 0}
      {maxLength !== undefined ? `/${maxLength}` : ""} words
    </div>
  );
});
